import { useTranslation } from 'react-i18next'

import { PdfViewerToolbarMenu } from '../../PdfViewerToolbarMenu'

import {
  PDF_VIEWER_TOOLBAR_VIEW_CONTROLS_ICON_PROPS,
  QA_NAME_PDF_VIEWER_TOOLBAR_VIEW_CONTROLS_BTN,
} from './PdfViewerToolbarViewControlsTool.constants'
import { getPdfViewerViewControlsSections } from './PdfViewerToolbarViewControlsTool.utils'

import * as styles from './PdfViewerToolbarViewControlsTool.module.css'

function PdfViewerToolbarViewControlsTool({
  scrollMode,
  spreadMode,
  onChangeScrollMode,
  onChangeSpreadMode,
  onRotateClockwise,
  onRotateCounterClockwise,
}) {
  const { t } = useTranslation()

  return (
    <PdfViewerToolbarMenu
      beforeIconProps={PDF_VIEWER_TOOLBAR_VIEW_CONTROLS_ICON_PROPS}
      buttonClassName={styles.PdfViewerToolbarViewControlsTool}
      qaName={QA_NAME_PDF_VIEWER_TOOLBAR_VIEW_CONTROLS_BTN}
      sections={getPdfViewerViewControlsSections({
        scrollMode,
        spreadMode,
        onChangeScrollMode,
        onChangeSpreadMode,
        onRotateClockwise,
        onRotateCounterClockwise,
      })}
      tooltip={t('PdfViewer.ViewControlsBtnKey')}
    />
  )
}

export default PdfViewerToolbarViewControlsTool
